import { render } from "./SignUpArea.vue?vue&type=template&id=3f8d0994"
import script from "./SignUpArea.vue?vue&type=script&lang=js"
export * from "./SignUpArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__